module.exports = __webpack_public_path__ + "static/img/sororas-1.8be0da7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/portfolio/sororas-1.jpg
// module id = Fapn
// module chunks = 1